import { useCallback, useState } from 'react';
import { EPhoneVerificationStep, PHONE_STEP_TITLE } from '../constants';

interface IParams {
  initialStep: EPhoneVerificationStep;
}

export const useVerificationStep = ({ initialStep }: IParams) => {
  const [step, setStep] = useState<EPhoneVerificationStep>(initialStep);
  const gotToPhoneStep = useCallback(() => setStep(EPhoneVerificationStep.PHONE), []);
  const goToVerificationStep = useCallback(() => setStep(EPhoneVerificationStep.VERIFY), []);

  return {
    step,
    title: PHONE_STEP_TITLE[step],
    gotToPhoneStep,
    goToVerificationStep,
  };
};
